import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTag = () => {
  return (
    <g>
      <path d="M15.78.22c.269.269.291.69.067.985l-.067.077-1.66 1.66.695.696a.75.75 0 0 1 .208.398l.012.115.101 4.166a.751.751 0 0 1-.14.456l-.08.093-6.912 6.914a.75.75 0 0 1-.977.073l-.084-.073L.22 9.055a.751.751 0 0 1-.073-.978l.073-.084L7.132 1.08a.75.75 0 0 1 .426-.213L7.679.86l4.156.092a.75.75 0 0 1 .426.145l.088.075.71.709 1.66-1.66a.75.75 0 0 1 1.061 0zm-2.239 4.266-.482-.483-.709.71c.377.792.265 1.759-.336 2.447l-.105.113a2.251 2.251 0 1 1-3.185-3.186 2.252 2.252 0 0 1 2.567-.438l.706-.708-.496-.496-3.533-.078-6.156 6.157 5.662 5.663 6.153-6.156-.086-3.545zm-2.694.663A.75.75 0 1 0 9.786 6.21a.75.75 0 0 0 1.061-1.06z" />
    </g>
  );
};

export default withIcon(IconTag);
